import { render, staticRenderFns } from "./GeneralBalance.vue?vue&type=template&id=476d0c7b&scoped=true"
import script from "./GeneralBalance.vue?vue&type=script&lang=js"
export * from "./GeneralBalance.vue?vue&type=script&lang=js"
import style0 from "./GeneralBalance.vue?vue&type=style&index=0&id=476d0c7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476d0c7b",
  null
  
)

export default component.exports